import { Injectable } from '@angular/core';
import { IconedRadioOption } from '@modules/core/interfaces';
import { PaymentOptionsEnum, RadioOptionsEnum } from '@modules/core/enums';
import { Store } from '@ngrx/store';
import { combineLatestWith, Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { selectIsActivatedPaymentProvider, selectIsAllowUnpaidOrders } from '@public-page/store/company';

@Injectable({
  providedIn: 'root',
})
export class RadioButtonsService {
  constructor(private store: Store) {}

  public generateIconedRadioOptions(type: RadioOptionsEnum): Observable<IconedRadioOption[]> {
    if (RadioOptionsEnum.PAYMENT_OPTIONS === type) {
      return this.generateIconedPaymentOptions();
    }

    return of([]);
  }

  private generateIconedPaymentOptions(): Observable<IconedRadioOption[]> {
    const isAllowUnpaidOrders$ = this.store.select(selectIsAllowUnpaidOrders);
    const isActivatedPaymentProvider$ = this.store.select(selectIsActivatedPaymentProvider);
    const iconedPaymentButtons: IconedRadioOption[] = [
      {
        value: PaymentOptionsEnum.ONLINE,
        icon: 'credit-card',
        label: 'bookingPage.confirmAppointmentPage.paymentSection.options.payOnline',
      },
      {
        value: PaymentOptionsEnum.ON_SITE,
        icon: 'pay',
        label: 'bookingPage.confirmAppointmentPage.paymentSection.options.payOnSite',
      },
    ];

    return of(iconedPaymentButtons).pipe(
      combineLatestWith(isAllowUnpaidOrders$, isActivatedPaymentProvider$),
      map(([buttons, isAllowUnpaidOrders, isActivatedPaymentProvider]) => {
        return isActivatedPaymentProvider && isAllowUnpaidOrders ? buttons : [];
      })
    );
  }
}
